# This file is automatically compiled by Webpack, along with any other files
# present in this directory. You're encouraged to place your actual application logic in
# a relevant structure within app/javascript and only use these pack files to reference
# that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()


# Uncomment to copy all static images under ../images to the output folder and reference
# them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
# or the `imagePath` JavaScript helper below.
#
# const images = require.context('../images', true)
# const imagePath = (name) => images(name, true)

require("trix")
require("@rails/actiontext")
require('jquery')

global.moment = require('moment')
require 'tempusdominus-bootstrap-4'
import 'tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css'

window.GM ||= {}

GM.initializeFormActions = ->
  $('form').each (ix, form) ->
    form = $(form)
    dependencies_path = form.data('dependencies')
    if dependencies_path
      form.on 'change', ':input', (elem) ->
        $.ajax(
          url: dependencies_path
          method: 'PATCH'
          data:
            authenticity_token: $(form).find('#authenticity_token').val()
            attribute: elem.target.name
            value: elem.target.value
        ).done ->
          console.log 'done'

$ ->
  initialize = ->
    GM.initializeFormActions()
    $('.datepicker').datetimepicker(
      locale: 'de'
      format: 'L'
    )
    $('.timepicker').datetimepicker(
      locale: 'de'
      format: 'LT'
    )
  $(document).ready(initialize)
  $(document).on('turbolinks:load', initialize)

  $(document).on 'click', '.add-file', ->
    tfoot = $(@).parents('tfoot')
    $.ajax(
      url: $(@).data('url')
      data: { file: tfoot.find("input[type='file']").val(), name: tfoot.find('input.file-name').val() }
      dataType: 'script'
    )
    false

  $(document).on 'click', '.add-link', ->
    tfoot = $(@).parents('tfoot')
    $.ajax(
      url: $(@).data('url')
      data: { url: tfoot.find('input.url-field').val(), title: tfoot.find('input.title-field').val() }
    )
    false

  $(document).on 'click', '.remove-row', ->
    $(@).parents('tr').replaceWith('')
    false

  $(document).on 'click', '.remove-link', ->
    (tr = $(@).parents('tr')).hide()
    tr.find('.remove-field').val(true)
    false
